import API from '@/api'
const state = {
  UserPortalData: {},
  courseApplyTypes: []
}

const mutations = {
  SET_USER_PORTAL_DATA(state, data) {
    state.UserPortalData = data
  },
  SET_COURSE_APPLY_TYPES(state, data) {
    state.courseApplyTypes = data
  }
}

const actions = {
  uploadFile(_, data) {
    return API.uploadFile(data)
  },
  UserPortalData({ commit }) {
    API.UserPortalData().then((res) => {
      if (+res.code === 200) {
        const newObj = {}
        for (const item in res.data) {
          newObj[item] = []
          for (const citem in res.data[item]) {
            if (Object.hasOwnProperty.call(res.data[item], citem)) {
              const element = res.data[item][citem]
              newObj[item].push({ id: citem, title: element })
            }
          }
        }

        commit('SET_USER_PORTAL_DATA', newObj)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
